// extracted by mini-css-extract-plugin
export default {"base":"EmptyMap_base__ibwn-","loading":"EmptyMap_loading__Uv7bt"};